module.exports = __webpack_public_path__ + "static/media/teachers evaluation.ed92e713.svg";